var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMigrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 70,
    viewBox: "0 0 216 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 40.726V58a4 4 0 0 0 4 4h70a4 4 0 0 0 4-4v-2h13c2 0 3.658-1.469 3.953-3.387 1.293 1.193 3.259 2.321 5.897 3.387 5 0 9.054 3.134 9.054 7s-4.053 7-9.054 7H59.497c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7H9.054C4.054 56 0 52.866 0 49s4.054-7 9.054-7H60.79c1.94 0 3.737-.471 5.21-1.274Zm0-11.452C64.527 28.471 62.73 28 60.79 28H28.455c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7H66v15.274ZM71.23 8a5.49 5.49 0 0 1-.092-1c0-3.866 4.053-7 9.054-7h126.754c5 0 9.054 3.134 9.054 7s-4.054 7-9.054 7H161V6a4 4 0 0 0-4-4H87a4 4 0 0 0-4 4v2H71.23ZM161 15.619c1.994 1.284 3.263 3.218 3.263 5.381 0 2.163-1.269 4.097-3.263 5.381V15.62ZM161 28h22.665c5 0 9.054 3.134 9.054 7s-4.054 7-9.054 7h-13.16c-3.965 0-7.459 1.24-9.505 3.122V28Zm45.946 14c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7S216 31.134 216 35s-4.054 7-9.054 7Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 9.282V6a4 4 0 0 1 4-4h70a4 4 0 0 1 4 4v46a4 4 0 0 1-4 4h-14.025",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    x: 67.25,
    y: 9.25,
    width: 75.5,
    height: 51.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.01 28.013 16.986-.011a3 3 0 0 1 3.002 3.002l-.01 11.985a3 3 0 0 1-2.998 2.998l-16.986.011a3 3 0 0 1-3.002-3.002l.01-11.985a3 3 0 0 1 2.998-2.998Z",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114 40.942 2.812-2.63a.968.968 0 0 1 1.342.013l2.048 1.948a.243.243 0 0 0 .352-.014l3.603-3.929a.973.973 0 0 1 1.46-.001c.026.028.05.058.073.09L129 41M142.317 18H82h60.317ZM99 32.5H76h23Zm.219 4.5h-23.59 23.59Zm0 6h-23.59 23.59Zm0 4h-23.59 23.59ZM78.266 17.5H69h9.266Z",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrations);
export default __webpack_public_path__ + "static/media/migrations.a0e672f4632c68885f30483a0c4c1b3a.svg";
export { ForwardRef as ReactComponent };